import * as React from 'react';
import dateTimeFormat from 'lib/dateTimeFormat';

/**
 * ## Displays a date formatted by Intl.DateTimeFormat.
 * ### Renders only the supplied props. Prefer [Timestamp](/internal/components/Timestamp) unless you need a specifc output.
 *
 *
 * ```example
 * <Time date={new Date()} />
 * ```
 *
 * ```example
 * <Time
 *   date={new Date()}
 *   year="numeric"
 *   month="long"
 *   weekday="long"
 *   day="numeric"
 *   hour="numeric"
 *   hour12={false}
 *   minute="numeric"
 *   timeZoneName="long"
 * />
 * ```
 *
 * ```example
 * <Time
 *   date={new Date()}
 *   year="numeric"
 * />
 * ```
 *
 * ```example
 * <Time
 *   date={new Date()}
 *   year="2-digit"
 * />
 * ```
 *
 * ```example
 * <Time
 *   date={new Date()}
 *   month="narrow"
 * />
 * ```
 *
 * ```example
 * <Time
 *   date={new Date()}
 *   month="short"
 * />
 * ```
 *
 *
 * # TODO
 * * What is `timeZone` prop?
 */

type Props = {
  date: Date;
  year?: 'numeric' | '2-digit';
  month?: 'numeric' | '2-digit' | 'narrow' | 'short' | 'long';
  weekday?: 'narrow' | 'short' | 'long';
  day?: 'numeric' | '2-digit';
  hour?: 'numeric' | '2-digit';
  hour12?: boolean;
  minute?: 'numeric' | '2-digit';
  second?: 'numeric' | '2-digit';
  timeZone?: boolean;
  timeZoneName?: 'short' | 'long';
  className?: string;
};

export default function Time(props: Props) {
  const { className, date, ...rest } = props;

  return <span className={className}>{dateTimeFormat(date, rest)}</span>;
}
